import { useMutation } from "@tanstack/react-query";
import type {
	InfractionAttachmentSlotKey,
	InfractionAttachmentSlots,
	InfractionEditAttachmentFormValues,
} from "../handlers/map-infraction-attachments-to-slots";
import {
	buildDesiredAttachmentsState,
	updateInfraction,
} from "../services/infractions.service";
import type { UpdateInfractionRequest } from "../types/infraction-api.types";

type UpdateInfractionVariables = {
	infractionId: number;
	vehicleId: number;
	payload: UpdateInfractionRequest;
	attachmentValues: InfractionEditAttachmentFormValues;
	originalAttachmentSlots: InfractionAttachmentSlots;
	removedAttachmentSlotKeys: InfractionAttachmentSlotKey[];
};

export function useUpdateInfraction() {
	return useMutation({
		mutationKey: ["infractions", "update"],
		mutationFn: async ({
			infractionId,
			vehicleId,
			payload,
			attachmentValues,
			originalAttachmentSlots,
			removedAttachmentSlotKeys,
		}: UpdateInfractionVariables) => {
			const attachments = await buildDesiredAttachmentsState({
				vehicleId,
				values: attachmentValues,
				originalSlots: originalAttachmentSlots,
				removedSlotKeys: new Set(removedAttachmentSlotKeys),
			});

			return updateInfraction(infractionId, {
				...payload,
				attachments,
			});
		},
	});
}
